import userApi from '../../../../api/userApi';
import { AccountType } from '../../../../api/userApi/types';
import {
  StyledPaygLabel,
  StyledFreeTierLabel,
  SubscribedLabel,
} from './styled';

const AccountTypeLabel = () => {
  const { data: userInfo } = userApi.useGetUserInfoQuery();

  switch (userInfo?.apiSettings.status) {
    case AccountType.Free:
      return <StyledFreeTierLabel>Free Tier</StyledFreeTierLabel>;
    case AccountType.Subscribed:
      return <SubscribedLabel>Subscription</SubscribedLabel>;
    case AccountType.Payg:
      return <StyledPaygLabel>Pay As You Go</StyledPaygLabel>;
    default:
      return null;
  }
};

export default AccountTypeLabel;
